module.exports = __webpack_public_path__ + "static/media/home-restaurant.c1a8906f.svg";